import { useEffect, useState } from 'react'
import posthog from '../utils/posthog'

export const usePostHog = () => {
  const [isReady, setIsReady] = useState(false)

  useEffect(() => {
    if (typeof window !== 'undefined') {
      setIsReady(true)
    }
  }, [])

  const identify = (userId, userProperties = {}) => {
    if (isReady) {
      posthog.identify(userId, userProperties)
    }
  }

  const capture = (eventName, properties = {}) => {
    if (isReady) {
      posthog.capture(eventName, properties)
    }
  }

  const setUserProperties = (properties) => {
    if (isReady) {
      posthog.set(properties)
    }
  }

  const reset = () => {
    if (isReady) {
      posthog.reset()
    }
  }

  return {
    isReady,
    identify,
    capture,
    setUserProperties,
    reset,
    posthog: isReady ? posthog : null
  }
} 